import { render, staticRenderFns } from "./ActivationMsg.vue?vue&type=template&id=0c420474&scoped=true&"
import script from "./ActivationMsg.vue?vue&type=script&lang=js&"
export * from "./ActivationMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c420474",
  null
  
)

export default component.exports